import React, { useEffect, useState } from 'react'
import { AddressElement} from '@stripe/react-stripe-js'
import { useElements } from '@stripe/react-stripe-js';
// import pubsub from "@viewlift/pubsub"
// import { updateMonetizationStore } from '../../updateStore'

const StripeAddressForm = ({ moduleData, isDisabled }) => {
    const elements = useElements();
    const disableCtaColor = "rgb(183 186 194)"

    const appearance = {
        theme: 'night',
        variables: {
          colorPrimary: "#979797",
          colorBackground: disableCtaColor || "#000",
          colorText: moduleData?.layout?.settings?.cardTextColor || "#000",
          colorDanger: '#a4a4a4',
          spacingUnit: '3px',
          borderRadius: '4px',
          marginBottom : '10px',
          fontSizeBase: 'fontSizeSm',
          tabSpacing : '3px'
        },
        rules: {
            '.Input': {
                border : "none",
                boxShadow : 'none',
                colorText : "#000"
            },
            '.Input::placeholder' : {
                colorText : 'rgba(89, 93, 102, 1)'
            },
            '.Input:focus' : {
                border : "none",
                boxShadow : 'none'
            },
            '.Label' : {
                color : "#595d66"
            }
        }
      }

    useEffect(() => {
        if(!isDisabled) {
            appearance.variables.colorBackground = moduleData?.layout?.settings?.inputColor
        }
        elements.update({appearance})
    }, [isDisabled])

    let enableAddressForm = window?.app_data?.appcmsMain?.paymentProviders?.stripe?.showPaymentAddress

    return (
        <div className="address-form" style={{marginTop : "10px", marginBottom: "1rem"}}>
            <div className={isDisabled ? 'address-form-disable-wrapper disabled-containter' : 'address-form-disable-wrapper'}>
            </div>
            <AddressElement
                options={{
                    mode: 'billing',
                    ...(enableAddressForm && { fields: { line1: 'always', city: 'always', state: 'always', postalCode: 'always', country: 'always' } }),
                }}
            />
        </div>
    )
}

export default StripeAddressForm